import React, { useState } from 'react'
import { useParams } from 'react-router'
import CustomViewForm from '../components/CustomViewForm'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import ProductView from '../components/version-4/viewForms/ProductsView'
import ViewImage from '../components/ViewImage'
import { useProduct } from '../hooks/Features/useProduct'
import { formatNumber, isValidUrl, ROUTES } from '../shared/constants'

function ViewProducts() {
  const { getProduct, product } = useProduct()
  const params = useParams()
  const [data, setData] = useState([])
  //console.log('DATA : ', data)
  React.useEffect(() => {
    getProduct({ productId: params.productId })
  }, [params.productId])

  React.useEffect(() => {
    if (product) {
      setData([
        { label: 'Category', data: product.categoryId && product.categoryId.categoryName },
        { label: 'SubCategory', data: product.subCategoryId && product.subCategoryId.name },
        { label: 'Name', data: product.name },
        { label: 'Color', data: product.color },
        { label: 'SKU', data: product.sku },
        { label: 'Distributor Price', data: formatNumber(product.distributorPrice) },
        { label: 'Dealer Price', data: formatNumber(product.dealerPrice) },
        { label: 'Stock', data: product.stocks },
        { label: 'Description', data: product.description },
        { label: 'Primary Image', data: <ViewImage image={isValidUrl(product.primaryImage)} /> },
        { label: 'Secondary Image', data: <ViewImage image={isValidUrl(product.secondaryImage)} /> },
        // { label: 'Secondary Variants', data: product.secondaryVariant, type: 'Array', field: 'name', field2: 'sku' },
        { label: 'Must Item', data: product.mustItem, type: 'Array', field: 'name', field2: 'sku' },
      ])
    }
  }, [product])

  console.log({ product })
  console.log('Data', data)

  return (
    <Layout heading="Product" heading2="Info" url1={ROUTES.PRODUCTS} none>
      {!product ? <Loader /> : <HeaderTabLayout heading="Product" content={<CustomViewForm data={data} />} view url={`/edit-product/${params.productId}`} />}
    </Layout>
  )
}

export default ViewProducts
